export default __webpack_public_path__ + "static/media/crown.6df64077.png";